import { useMemo } from 'react';
import { AIChat } from '@features/ai/AIChat/AIChat';
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import { SurveyModelMinimalUtrv } from '@g17eco/types/survey';
import { UniversalTrackerPlain } from '@g17eco/types/universalTracker';
import { generateId } from '../../../utils';

interface DataIntegrationsProps {
  utr: Pick<UniversalTrackerPlain, '_id'>;
  utrv: Pick<SurveyModelMinimalUtrv, '_id' | 'initiativeId'>;
}

export const DataIntegrations = (props: DataIntegrationsProps) => {
  const { utr, utrv } = props;

  const user = useCurrentUser();
  const userId = user._id;
  const randomId = useMemo(() => generateId(), []);

  return (
    <AIChat
      initiativeId={utrv.initiativeId}
      conversationId={`${userId}-${utrv._id}-${randomId}`}
      initialContext={{
        type: 'QuestionView',
        utrId: utr._id,
        utrvId: utrv._id,
      }}
    />
  );
};
